<template>
  <!-- {{ auction.halt_bidding }} - {{ bidding_halted }} -->
  <div
    class="container border rounded h-50 border-primary"
    v-if="live_player.id"
  >
    <div class="row mt-2">
      <div class="col">
        <PlayerPhoto :player_id="live_player.id"></PlayerPhoto>
      </div>
      <div class="col">
        <span class="fw-bold"> {{ live_player.name }} </span>
        <PlayerStats :player_id="live_player.id"></PlayerStats>
      </div>
    </div>
    <div class="p-1" v-if="!bidding_halted">
      <BidButtons :player_id="props.player_id"></BidButtons>
    </div>
  </div>
</template>
<script setup>
import { defineProps, ref, onMounted, computed } from "vue";
import PlayerPhoto from "./PlayerPhoto.vue";
import BidButtons from "../bidbuttons/BiddingButtons.vue";
import PlayerStats from "../../auctioneer/liveplayer/PlayerStats.vue";
import supabase from "@/supabase/config";
const props = defineProps(["player_id", "halt_bidding"]);
import { useStore } from "@/store/index";
const store = useStore();
const live_player = ref({});
const auction = ref({});
const bidding_halted = computed(() => {
  var halt = true;
  if (auction.value.id) {
    halt = auction.value.halt_bidding;
  }
  return halt;
});
onMounted(() => {
  setTimeout(() => {
    fetchPlayer();
    fetchAuction();
  }, 250);
});
const fetchAuction = async () => {
  let { data: auctions, error } = await supabase
    .from("auctions")
    .select("*")
    .eq("id", store.live_auction);
  auction.value = auctions[0];
  setupAuctionListner();
};
const setupAuctionListner = () => {
  const channels = supabase
    .channel("bid-button-halt-bidding-custom-update-channel")
    .on(
      "postgres_changes",
      { event: "UPDATE", schema: "public", table: "auctions" },
      (payload) => {
        if (payload.new.id == store.live_auction) {
          auction.value = payload.new;
        }
        //console.log("Change received!", payload);
      }
    )
    .subscribe();
};
const fetchPlayer = async () => {
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("id", props.player_id);
  live_player.value = players[0];
  setupListnerToPlayer();
};
const setupListnerToPlayer = () => {};
</script>
